<!--  -->
<template>
  <div class="cold-humidity">
    <div id="coldTemperatureChart" style="height: 100%; width: 98%"></div>
  </div>
</template>

<script>
import charts from "echarts";
import API from "../api/index";
export default {
  data() {
    return {
      coldTemperatureChart: null,
      coldTemperatureChartOption: {},
      xAxisData: [],
      listData: [],
      listKeysList: [],
      listKeys: {},
    };
  },

  components: {},

  // computed() {},

  mounted() {
    var self = this;

    self.coldTemperatureChart = charts.init(
      document.getElementById("coldTemperatureChart")
    );
    self.queryData().then((res) => {
      self.initChart();
    });
  },

  methods: {
    queryData() {
      // this.xData = [];
      // this.yData = [];
      return new Promise((resolve, reject) => {
        this.$fetch(API.statAvgTemperatureAndhumidity, { statType: "1" }).then(
          (res) => {
            if (res.success) {
              res.returnObj.forEach((item, index) => {
                this.listKeysList = [];
                this.xAxisData.push(item.hours);
                // this.listKeysList = Object.keys(item.dataMap);
                if (index == 0) {
                  for (let key in item.dataMap) {
                    // this.listKeysList.push(key);
                    // this.listKeys[key] = [];
                    this.listData.push({
                      name: key,
                      list: [],
                    });
                    // this.listKeys[key].push(item.dataMap[key]);
                    // this.listData.push({
                    //   name: key,
                    //   list: ,
                    // });
                  }
                }

                // this.listKeysList.forEach((el) => {
                //   this.listKeys.set(el,)
                //   // if (el in item.dataMap) {]
                //   //   this.listKeys[el].push(item.dataMap[el]);
                //   // }
                // });
              });
              res.returnObj.forEach((item) => {
                for (let key in item.dataMap) {
                  this.listData = this.listData.map((el, inde) => {
                    let re = {
                      name: el.name,
                      list: [...el.list],
                    };
                    if (el.name === key) {
                      re.list.push(item.dataMap[key]);
                      // console.log(true, inde, ">>>true");
                    }
                    // console.log(re, ">>>>>re");
                    return re;
                  });
                  // this.listKeys[key] = item.dataMap[key];
                }
              });
              resolve(this.listData);
              // console.log(this.listKeys, this.listData, ">>>> this.listKeys");

              // this.coldData = res.returnObj;
              // for (let key in this.coldData) {
              //   this.xData.push(key);
              //   this.yData.push(this.coldData[key]);
              // }
              // resolve(this.coldData);
            } else {
              this.$message.error(res.msgContent);
            }
          }
        );
      });
    },
    initChart() {
      const color = [
        "#00ADEF",
        "#FF6969",
        "#9BD342",
        "#FFDA00",
        "#AB4CD3",
        "#FB4CD3",
      ];
      // const xAxisData = [
      //   "0:00",
      //   "4:00",
      //   "8:00",
      //   "12:00",
      //   "16:00",
      //   "20:00",
      //   "24:00",
      // ];
      const yAxisData1 = [30, 35, 32, 30, 20, 45, 25];
      const yAxisData2 = [35, 30, 35, 30, 30, 48, 30];
      const yAxisData3 = [32, 41, 34, 35, 35, 46, 47];
      const yAxisData4 = [41, 32, 32, 45, 45, 45, 46];
      const yAxisData5 = [45, 45, 32, 34, 46, 42, 44];
      const yAxisData6 = [34, 35, 46, 35, 47, 46, 47];

      const listData = [
        { name: "一号", list: yAxisData1 },
        { name: "二号", list: yAxisData2 },
        { name: "三号", list: yAxisData3 },
        { name: "四号", list: yAxisData4 },
        { name: "五号", list: yAxisData5 },
        { name: "六号", list: yAxisData6 },
      ];
      const yDatas = [];
      // for (let key in this.listKeys) {
      //   yDatas.push({
      //     name: key,
      //     type: "line",
      //     lineStyle: {
      //       normal: {
      //         color: color[index],
      //         width: 2,
      //       },
      //     },
      //     //   itemStyle: {
      //     //     normal: {
      //     //       label: {
      //     //         show: true,
      //     //         position: "top",
      //     //         textStyle: {
      //     //           color: "#C23531",
      //     //           fontSize: 12,
      //     //         },
      //     //       },
      //     //     },
      //     //   },
      //     data: this.listKeys[key],
      //   });
      // }
      const leftData = this.listData.slice(0, 3)
      leftData.forEach((item, index) => {
        yDatas.push({
          name: item.name,
          type: "line",
          lineStyle: {
            normal: {
              color: color[index],
              width: 2,
            },
          },
          //   itemStyle: {
          //     normal: {
          //       label: {
          //         show: true,
          //         position: "top",
          //         textStyle: {
          //           color: "#C23531",
          //           fontSize: 12,
          //         },
          //       },
          //     },
          //   },
          data: leftData[index].list,
        });
      });
      //   {
      //     name: "入园",
      //     type: "line",
      //     showSymbol: false,
      //     lineStyle: {
      //       normal: {
      //         color: color[0],
      //         width: 2,
      //       },
      //     },
      //     data: yAxisData1,
      //   },

      const option = {
        color: color,
        legend: {
          icon: "rect",
          itemHeight: 6,
          itemWidth: 6,
          textStyle: {
            color: "#ffffff",
          },
          right: 0,
          top: 0,
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: 50,
          left: 10,
          bottom: 10,
          right: 30,
          containLabel: true,
        },
        xAxis: [
          {
            name: "时",
            type: "category",
            boundaryGap: false,
            axisLabel: {
              textStyle: {
                color: "#E4F5FD",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#E4F5FD",
              },
            },
            data: this.xAxisData,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "单位：℃",
            axisLabel: {
              textStyle: {
                color: "#E4F5FD",
              },
            },
            nameTextStyle: {
              color: "#E4F5FD",
              fontSize: 12,
              lineHeight: 40,
              padding: [0, 0, 0, 30]
            },
            splitLine: {
              lineStyle: {
                type: "dashed",
                color: "rgba(230,247,255,0.2)",
              },
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
          },
        ],
        // position: "top",
        series: yDatas,
        // series: [
        //   {
        //     name: "入园",
        //     type: "line",
        //     showSymbol: false,
        //     lineStyle: {
        //       normal: {
        //         color: color[0],
        //         width: 2,
        //       },
        //     },
        //     data: yAxisData1,
        //   },
        //   {
        //     name: "出园",
        //     type: "line",
        //     showSymbol: false,
        //     lineStyle: {
        //       normal: {
        //         color: color[1],
        //         width: 2,
        //       },
        //     },
        //     data: yAxisData2,
        //   },
        // ],
      };
      this.coldTemperatureChart = charts.init(
        document.getElementById("coldTemperatureChart")
      );
      this.coldTemperatureChart.setOption(option);
    },
  },
};
</script>
<style lang='scss' scoped>
.cold-humidity {
  height: 100%;
}
</style>